import React, { useState, useMemo } from "react";
import { Card, Button, Col, Row, Form } from "react-bootstrap";

export default function InscripcionFinalesCard({
  datos,
  accion,
  btnIcon,
  btnVariant,
  btnTitle,
}) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredAndSortedDatos = useMemo(() => {
    if (!datos || datos.length === 0) {
      return [];
    }
    let filtered = datos.filter((mesa) => {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      return (
        mesa.materia.toLowerCase().includes(lowerCaseSearchTerm) ||
        (mesa.profes &&
          String(mesa.profes).toLowerCase().includes(lowerCaseSearchTerm))
      );
    });
    return filtered.sort((a, b) =>
      a.materia.localeCompare(b.materia, "es", { sensitivity: "accent" })
    );
  }, [datos, searchTerm]);

  if (!datos || datos.length === 0) {
    return <p className="text-center">No hay finales para mostrar.</p>;
  }

  return (
    <>
      <Form.Group className="mb-3" controlId="formBasicSearch">
        <Form.Control
          type="text"
          placeholder="Buscar por mesa o profesor..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Form.Group>
      <div className="card-container-scrollable">
        {filteredAndSortedDatos.length === 0 ? (
          <p className="text-center">
            No se encontraron finales con los criterios de búsqueda.
          </p>
        ) : (
          <Row xs={1} md={2} lg={3} className="g-4">
            {filteredAndSortedDatos.map((data) => (
              <Col key={data.id}>
                <Card className="h-100 shadow card-fixed-height">
                  <Card.Header as="h5">{data.materia}</Card.Header>
                  <Card.Body>
                    <Card.Text>
                      <strong>Horarios:</strong> {data.fechaExamen} -{" "}
                      {data.horaExamen}
                    </Card.Text>
                    <Card.Text>
                      <strong>Profesor(es):</strong> {data.profes}
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>
                    <Button
                      onClick={() => accion({ mesaSelected: { data: data } })}
                      variant={btnVariant}
                      title={btnTitle}
                      disabled={data.disabled}
                      className="w-100"
                    >
                      {btnIcon} {btnTitle}
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </>
  );
}
